"use client";
import React, { useState, useCallback, useMemo } from "react";
import { Button, Nav, Navbar, Offcanvas, Container } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import LangSelector from "../languages/LangSelector";

function Header({ isSticky, navItems }) {
  const { t } = useTranslation("global");
  const [showSidebar, setShowSidebar] = useState(false);
  const { lang, slug } = useParams();
  const navigate = useNavigate();
  
  const handleSidebarClose = useCallback(() => setShowSidebar(false), []);
  const handleSidebarOpen = useCallback(() => setShowSidebar(true), []);
  
  const handleLoginClick = useCallback(() => navigate(`/ar/auth/login`), [navigate]);
  const handleRegisterClick = useCallback(() => navigate(`/ar/auth/register/choice`), [navigate]);
  
  const logo =
    "https://ecombo.sgp1.cdn.digitaloceanspaces.com/assets/Logo_Ecombo 1.png";

  // Default nav items if not provided
  const resolvedNavItems = navItems || [];
  
  const defaultNavItems = useMemo(() => [
    ...resolvedNavItems,
    {
      labelKey: "static_home.header.login",
      isButton: true,
      onClick: handleLoginClick,
      buttonProps: {
        variant: "secondary",
        className: "mx-2   ecombo-btn-secondary w-100",
      },
    },
    {
      labelKey: "static_home.header.register",
      isButton: true,
      onClick: handleRegisterClick,
      buttonProps: {
        variant: "secondary",
        className: "mx-2 ecombo-btn-secondary w-100",
      },
    },
  ], [resolvedNavItems, handleLoginClick, handleRegisterClick]);

  return (
    <Navbar
      dir={lang === "en" ? "ltr" : "rtl"}
      expand="lg"
      bg="white"
      fixed={isSticky ? "top" : undefined}
      className={`shadow-lg transition-all duration-300 ${
        isSticky ? "z-50" : ""
      }`}
    >
      <Container>
        <Navbar.Brand className="d-flex align-items-center ">
          <img
            onClick={() => navigate("/")}
            style={{ cursor: "pointer" }}
            src={logo}
            alt="ايكومبو"
            width={150}
            height={44}
          />
          <LangSelector slug={slug} lang={lang} />
        </Navbar.Brand>

        <Navbar.Toggle
          aria-controls="navbar-offcanvas"
          onClick={handleSidebarOpen}
        />

        <Navbar.Collapse id="navbar-offcanvas" className="justify-content-end">
          <Nav>
            {defaultNavItems.map((item, idx) => (
              <Nav.Link
                key={item.labelKey || idx}
                href={item.href || "#"}
                className={item.isButton ? 'px-1 py-1' : "text-textBase text-xl"}
                onClick={item.onClick}
                style={item.isButton ? { padding: 0 } : undefined}
              >
                {item.isButton ? (
                   <Button className="w-100" {...(item.buttonProps || {})} onClick={item.onClick}>
                    {t(item.labelKey)}
                  </Button>
                 ) : (
                  t(item.labelKey)
                )}
              </Nav.Link>
            ))}
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default Header;
